module.exports = __webpack_public_path__ + "img/logo29.e1828f03.png";